import { Component, inject, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginLayoutComponent } from './login/login-layout.component';
import { AuthStore, OAuthStore } from '@core/auth';

@Component({
  selector: 'app-root-layout',
  standalone: true,
  imports: [LoginLayoutComponent, RouterOutlet],
  template: `
    <div class="root-layout h-screen w-screen app-content">
      @if (showLoginLayout()) {
        <app-login-layout />
      } @else {
        <router-outlet />
      }
    </div>
  `,
  styles: [
    `
      .app-content {
        background: var(--md-sys-color-surface);
      }
    `,
  ],
})
export class RootLayoutComponent {
  private readonly authStore = inject(AuthStore);
  private readonly oauthStore = inject(OAuthStore);

  showLoginLayout = computed(
    () =>
      !this.authStore.isAuthenticated() && !this.oauthStore.isOAuthCallback()
  );
}
